import React, { Component } from 'react';
import {Form, Input, Select} from "antd";

const { TextArea } = Input;
const { Option } = Select;

class DisputeDetails extends Component{
    constructor(props) {
        super(props);
        this.state={
            type_list:[
                {value:'Dead On Arrival',key:'1'},
                {value:'Multiply Repair / Irreparable',key:'2'},
                {value:'Not Repaired Within Legally Stated Period',key:'3'},
            ],
            refund_rate:[
                {value:'5%',key:'1'},{value:'10%',key:'2'},{value:'15%',key:'3'},
                {value:'20%',key:'4'},{value:'25%',key:'5'},{value:'30%',key:'6'},
                {value:'35%',key:'7'},{value:'40%',key:'8'},{value:'45%',key:'9'},
                {value:'50%',key:'10'},{value:'55%',key:'11'},{value:'60%',key:'12'},
                {value:'65%',key:'13'},{value:'70%',key:'14'},{value:'75%',key:'15'},
                {value:'80%',key:'16'},{value:'85%',key:'17'},{value:'90%',key:'18'},
                {value:'95%',key:'19'},{value:'100%',key:'20'}
            ]
        }
    }
    render() {
        const {type_list,refund_rate} = this.state;
        return <div>
            {this.props.type==3?
                <div className="spaceBox ">
                    <Form.Item
                        label="Dispute Details"
                        style={{fontWeight:'bold'}}
                    >
                    </Form.Item>
                    <Form.Item
                        label="Requested Changes"
                        name={'RequestedChanges'}
                        rules={[{ required: true }]}
                    >
                        <TextArea maxLength={255}/>
                    </Form.Item>
                    <Form.Item
                        label="Requested VAT ID"
                        name={'RequestedVATID'}
                        rules={[{ required: true }]}
                    >
                        <Input maxLength={20} />
                    </Form.Item>
                    <Form.Item
                        label="Text To Appear On Credit Note"
                        name={'textOnCreditNote'}
                        rules={[{ required: false }]}
                    >
                        <Input maxLength={255} />
                    </Form.Item>
                    <Form.Item
                        label="Customer Internal Reference:"
                        name={'InternalReference'}
                        rules={[{ required: false }]}
                    >
                        <Input maxLength={40} />
                    </Form.Item>
                </div>
                :
                <div className="spaceBox ">
                <Form.Item
                label="Dispute Details"
                style={{fontWeight:'bold'}}
                >
                </Form.Item>
                {this.props.type==8?
                    <div>
                        <Form.Item
                            label="Type"
                            name={'Type'}
                            rules={[{ required: true}]}
                        >
                            <Select defaultValue="Please Select">
                                {
                                    type_list.map((item)=>{
                                        return <Option value={item.key} >{item.value}</Option>
                                    })
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="Refund Rate"
                            name={'Refund Rate'}
                            rules={[{ required: true}]}
                            initialValue={'100%'}
                        >
                            <Select defaultValue="Please Select">
                                {
                                    refund_rate.map((item)=>{
                                        return <Option value={item.key} >{item.value}</Option>
                                    })
                                }
                            </Select>
                        </Form.Item>

                    </div>
                    :''
                }
                {this.props.type==11?
                    <div>
                        <Form.Item
                            label="Disputed Amount"
                            name={'Disputed Amount'}
                            rules={[{ required: true}]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="Currency"
                            name={'currency'}
                            rules={[{ required: true}]}
                        >
                            <Select />
                        </Form.Item>
                        <Form.Item
                            label="Type"
                            name={'Type'}
                            rules={[{ required: true}]}
                        >
                            <Select />
                        </Form.Item>
                    </div>:''
                }
                <Form.Item
                label="Comments"
                name={'comments'}
                rules={[{ required: this.props.type==5 || this.props.type==11?false:true }]}
                >
                <TextArea maxLength={255} />
                </Form.Item>
                {this.props.type==2 || this.props.type==11 || this.props.type==12 && this.props.PPMass_checked?'':
                    <Form.Item
                        label="Text To Appear On Credit Note"
                        name={'textOnCreditNote'}
                        rules={[{ required: false}]}
                    >
                        <Input maxLength={255} />
                    </Form.Item>
                }
                {this.props.type==11 || this.props.PPMass_checked?'':
                    <Form.Item
                        label="Customer Internal Reference:"
                        name={'InternalReference'}
                        rules={[{ required: false}]}
                    >
                        <Input maxLength={40} />
                    </Form.Item>
                }
                </div>
            }
        </div>

    }
}

export default DisputeDetails;